import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent} from './Screens/login/login.component';
import { DashboardComponent} from './Screens/dashboard/dashboard.component';
import { NewUserComponent} from './Screens/new-user/new-user.component';
import { CommunityUserComponent } from './Screens/community-user/community-user.component';
import { UserStatusComponent } from './Screens/user-status/user-status.component';
import { ContentLauncherComponent } from './Screens/content-launcher/content-launcher.component';
import { IsolatedLoginComponent} from "./Screens/isolated-login/isolated-login.component";
import { IsolatedNewUserComponent} from "./Screens/isolated-new-user/isolated-new-user.component";
import { IsolatedProfileUpdateComponent} from "./Screens/isolated-profile-update/isolated-profile-update.component";
import { IsolatedPwdChangeComponent } from './Screens/isolated-pwd-change/isolated-pwd-change.component';
import { IsolatedScoreCardComponent } from './Screens/isolated-score-card/isolated-score-card.component';
import { IsolatedForgotPwdComponent } from './Screens/isolated-forgot-pwd/isolated-forgot-pwd.component';
import { IsolatedTendencyReportComponent } from './Screens/isolated-tendency-report/isolated-tendency-report.component';
import { IsolatedSubscriptionComponent } from './Screens/isolated-subscription/isolated-subscription.component';
import { CertificateLauncherComponent } from './Screens/certificate-launcher/certificate-launcher.component';
import { changepasswordComponent } from './Screens/ChangePassword/changepassword.component';
import {AuthGuard} from "./auth.guard";
import {BatchLinksComponent} from "./Screens/batch-links/batch-links.component";
import {ServerUnderMaintananceComponent} from "./Screens/server-under-maintanance/server-under-maintanance.component";
import { CognitoRouteComponent } from './Screens/cognito-route/cognito-route.component';
import { IdpLandingComponent } from './Screens/idp-landing/idp-landing.component';
/*import { LearnersModule } from './Screens/learners/learners.module';
import { AlignorAdminModule } from './Screens/alignor-admin/alignor-admin.module';*/

const routes: Routes = [
  { path:'', redirectTo: 'login',   pathMatch: 'full'},
  { path:'login',component:LoginComponent},
  { path:'idpLanding/:id',component:IdpLandingComponent},
  { path:'login/:id',component:LoginComponent },
  { path :'RegisterUser', component : NewUserComponent},
  { path :'RegisterUser/:id', component : NewUserComponent},
  { path :'communityUser', component : CommunityUserComponent},
  {path:'changePassword/:id',component:changepasswordComponent},
  { path:'cognitoRoute',component:CognitoRouteComponent},
  {path:'changePassword',component:changepasswordComponent},
  { path:'dashboard', component:DashboardComponent,

    children: [
/*      {path:'learner' ,loadChildren: ()=>LearnersModule},
      {path:'portal' ,loadChildren: ()=>AlignorAdminModule}*/
      {
        path: 'learner',
        loadChildren: './Screens/learners/learners.module#LearnersModule',
      },
      {
        path: 'portal',
        loadChildren: './Screens/alignor-admin/alignor-admin.module#AlignorAdminModule',
      }
    ]
  },
  {path:'isolatedLogin',component:IsolatedLoginComponent},
  {path:'isolatedLogin/:url',component:IsolatedLoginComponent},
  {path:'isolatedProfileUpdate',component:IsolatedProfileUpdateComponent},
  {path:'isolatedProfileUpdate/:url',component:IsolatedProfileUpdateComponent},
  {path:'isolatedForgotPWD',component:IsolatedForgotPwdComponent},
  {path:'isolatedForgotPWD/:url',component:IsolatedForgotPwdComponent},
  {path:'isolatedPWDChange',component:IsolatedPwdChangeComponent},
  {path:'isolatedPWDChange/:id',component:IsolatedPwdChangeComponent},
  {path:'isolatedPWDChange/:id/:url',component:IsolatedPwdChangeComponent},
  {path:'isolatedRegisterUser', component : IsolatedNewUserComponent},
  {path:'isolatedRegisterUser/:id', component : IsolatedNewUserComponent},
  {path:'isolatedRegisterUser/:id/:url', component : IsolatedNewUserComponent},
  {path:'isolatedScorecard',component:IsolatedScoreCardComponent},
  {path:'isolatedScorecard/:url',component:IsolatedScoreCardComponent},
  {path:'isolatedTendencyReport', component: IsolatedTendencyReportComponent},
  {path:'isolatedTendencyReport/:url', component: IsolatedTendencyReportComponent},
  {path:'access/:username',component:UserStatusComponent},
  {path:'certificateAccess/:username',component:CertificateLauncherComponent},
  {path:'contentLauncher/:comm_id/:token', component: ContentLauncherComponent},
  {path:'isolatedSubscription/:course_id', component: IsolatedSubscriptionComponent},
  {path:'isolatedSubscription/:course_id/:certId', component: IsolatedSubscriptionComponent},
  {path:'isolatedSubscription/:course_id/:certId/:url', component: IsolatedSubscriptionComponent},
  { path:'batchLinkDetails', component: BatchLinksComponent,canActivate: [AuthGuard],data: { onlyGuests: 'Learner' }},
  {path:'isolatedProfileUpdate',component:IsolatedProfileUpdateComponent},
  {path:'serverUnderMaintanance',component:ServerUnderMaintananceComponent},
  { path: '**', redirectTo: 'login'},
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts